import React from "react";
import { Button, Navbar } from "flowbite-react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <Navbar fluid rounded className="border-b-2">
      <Navbar.Brand href="/home">
        <img
          src={require("./Logo.jpg")}
          className="mr-3 h-7 sm:h-12"
          alt="wi_sol coffee"
        />
        <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
          Wi Sol
        </span>
      </Navbar.Brand>
      <div className="flex md:order-2">
        <Button href="https://m.me/61562925647117">Cần giúp?</Button>
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
        <Navbar.Link as={Link} to="/" active={currentPath === "/"}>
          Trang chủ
        </Navbar.Link>
        <Navbar.Link as={Link} to="/about" active={currentPath === "/about"}>
          Về wi_sol
        </Navbar.Link>

        <Navbar.Link
          as={Link}
          to="/product"
          active={currentPath === "/product"}
        >
          Sản phẩm
        </Navbar.Link>
        <Navbar.Link
          as={Link}
          to="/workshop"
          active={currentPath === "/workshop"}
        >
          Workshop
        </Navbar.Link>
        <Navbar.Link
          as={Link}
          to="/contact"
          active={currentPath === "/contact"}
        >
          Liên hệ
        </Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
}
